<ng-container *transloco="let t; prefix: 'credential-verification-level'">
  <div class="verification-level" [matTooltip]="t('tooltip.' + verificationLevel())">
    <accredible-icon [icon]="icon()" />

    <div>{{ t('user_uploaded') }}</div>
  </div>

  <div class="sr-only">
    {{ t('tooltip.' + verificationLevel()) }}
  </div>
</ng-container>
